( function( $ ) {
    //character countdown
    function initCharLimitCounter() {
        var $textareas = $( 'textarea' ).filter(function() {
            return ! $(this).data('charlimit-initialized');
        });

        if(!$($textareas).length) {
            return;
        }

        var maxLength = $( $textareas ).data('char-limit');
        var length = $($textareas).val().length;
        var length = maxLength-length;
        $($textareas).parent().find( '.charlimit' ).text( length );
        

        $textareas.on('keypress input change focus',  function() {
            if (!maxLength) {
                return;
            }

            var length = $(this).val().length;
            var length = maxLength-length;
            $(this).parent().find( '.charlimit' ).text( length );
        });

        //add div to show characters left
        $textareas.data('charlimit-initialized', true);
    }
    initCharLimitCounter();
} )( jQuery );